import axiosService from '@app/services/axiosService';
import { API_SCHOOL_ENDPOINT } from '@app/constants/api';
import _urlUtils from '@app/utils/url.utils';
import { ISchoolInvoiceForm } from '../interfaces/school-invoice-form.interface';

const BASE_URL = `${API_SCHOOL_ENDPOINT}/v1/bcn-school/tool-service/invoice-form`;

const schoolInvoiceFormApis = {
    getList(dataRequest: { currentPage: number; keyword?: string }) {
        const apiLink = _urlUtils.creatLinkSearch(BASE_URL, dataRequest);
        return axiosService.get(apiLink);
    },
    update(dataUpdate: ISchoolInvoiceForm) {
        return axiosService.put(BASE_URL, dataUpdate);
    },
};

export default schoolInvoiceFormApis;
